import { getService } from "../../axios/services";

export const getProjectAttachmentsForActivities = (projectId) =>
  getService({ endpoint: `projects/${projectId}/activities/attachments` });

export const getProjectAttachmentsWithoutActivities = (params) =>
  getService({ endpoint: "projects/activities/attachments", params });
